import { CharacterItemCollection, CharacterItemCollectionName, LocalCharacterInitializer } from "../../../../../entities/characters/Character";
import { OwnedItemReference } from "../../../../../entities/Ownership";
import { CharacterState } from "../CharacterStore.State";

const getCharacter = (state: CharacterState, characterId: string) => {
    const character = state.characters.find(c => c.id == characterId);
    if (character == null) {
        console.error(`Attempted to perform operation on unknown character ${characterId}`);
    }
    return character;
}

const updateCharacter = (state: CharacterState, newCharacter: LocalCharacterInitializer): CharacterState => {
    const newState = ({
        ...state,
        characters: [...state.characters.filter(c => c.id != newCharacter.id), newCharacter]
    });
    return newState;
}

/**
 * Creates an object with a collection of items mapping to a character's item collection, replacing the
 * item with the requested id with the input replacement.
 * @param character The character whose collection will be copied.
 * @param collectionName The name of the collection property to copy.
 * @param instanceId The instance id of the item to replace.
 * @param replaceWith The item to replace it with.
 */
const getItemCollectionWithReplacement = (character: LocalCharacterInitializer, collectionName: CharacterItemCollectionName, instanceId: string, replaceWith: OwnedItemReference): CharacterItemCollection => {
    switch (collectionName) {
        case 'held':
            return { ...character, held: [...character.held.filter(h => h.instanceId != instanceId), replaceWith] };
        case 'worn':
            return { ...character, worn: [...character.worn.filter(w => w.instanceId != instanceId), replaceWith] };
        case 'loose':
            return { ...character, loose: [...character.loose.filter(l => l.instanceId != instanceId), replaceWith] };
        case 'activeMods':
            return { ...character, activeMods: [...character.activeMods.filter(m => m.instanceId != instanceId), replaceWith] };
        case 'bodyMods':
            return { ...character, bodyMods: [...character.bodyMods.filter(m => m.instanceId != instanceId), replaceWith] };
    }
}

export const CharacterReducerHelpers = Object.freeze({
    getCharacter,
    updateCharacter,
    getItemCollectionWithReplacement,
});